import * as i0 from '@angular/core';
import { NgModule } from '@angular/core';
import { UserAccountComponentsModule } from '@spartacus/user/account/components';
import { UserAccountCoreModule } from '@spartacus/user/account/core';
import { UserAccountOccModule } from '@spartacus/user/account/occ';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class UserAccountModule {
  static {
    this.ɵfac = function UserAccountModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UserAccountModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: UserAccountModule,
      imports: [UserAccountCoreModule, UserAccountOccModule, UserAccountComponentsModule]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [UserAccountCoreModule, UserAccountOccModule, UserAccountComponentsModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserAccountModule, [{
    type: NgModule,
    args: [{
      imports: [UserAccountCoreModule, UserAccountOccModule, UserAccountComponentsModule]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/*
 * Public API Surface of user account
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UserAccountModule };
